import React from 'react';
import SideBar from '@fuww/library/src/Articles/Sections/Sidebar';
import { SideBarAdUnitContainer }
from '@fuww/library/src/Advertisement';
import dynamic from 'next/dynamic';
import AdUnit from '../../lib/adunit';
import jobsQuery from '../../lib/queries/jobs/jobsQuery.graphql';
import { useSiteContext } from '../SiteContext';
import InView from '../InView';
import loading from '../../lib/loading';

const MostRead = dynamic(
  () => import('./NewsList/Categories/MostRead'),
  {
    loading,
    ssr: false,
  },
);

const HighlightedJobs = dynamic(
  () => import('../Jobs/HighlightedJobs'),
  {
    loading,
    ssr: false,
  },
);

const jobErrorMessage = 'Error loading jobs...';

const highlightedJobsImageConfigurations = [
  { width: 42, quality: 10 },
  { width: 170 },
  { width: 340 },
  { width: 510 },
];

const HomeSideBar = () => {
  const { jobsLocale } = useSiteContext();
  const highlightedJobsVariables = {
    locales: jobsLocale,
    highlightLocale: jobsLocale,
    highlightType: 'JOB_OF_THE_WEEK',
    offset: 0,
    limit: 5,
    imageConfigurations: highlightedJobsImageConfigurations,
  };

  return (
    <SideBar
      adUnitItem={
        (
          <SideBarAdUnitContainer>
            <AdUnit
              adUnit="home_rectangle1"
              sizes={[[300, 250]]}
              minHeight="250px"
            />
          </SideBarAdUnitContainer>
        )
      }
      mostRead={
        (
          <InView>
            <MostRead showCategory showImage />
          </InView>
        )
      }
      highlightedJobs={
        (
          <InView>
            <HighlightedJobs
              query={jobsQuery}
              variables={highlightedJobsVariables}
              errorMessage={jobErrorMessage}
            />
          </InView>
        )
      }
    />
  );
};

export default HomeSideBar;
